import { render, staticRenderFns } from "./PlinForm.vue?vue&type=template&id=5a73b3fc&scoped=true"
import script from "./PlinForm.vue?vue&type=script&lang=js"
export * from "./PlinForm.vue?vue&type=script&lang=js"
import style0 from "./PlinForm.vue?vue&type=style&index=0&id=5a73b3fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a73b3fc",
  null
  
)

export default component.exports